import zlj_package from './zlj-package.vue'

const comment = {
  install: function (Vue) {
    Vue.component(zlj_package.name, zlj_package)
  }
}

if (typeof window !== "undefined" && window.Vue) {
  window.Vue.use(comment)
}

export default comment



// WEBPACK FOOTER //
// ./src/lib/index.js